import {useContext} from 'react';

import {SearchFormOverlayContext} from '@/modules/common/context/SearchFormOverlay/context';

export const useSearchFormOverlay = () => {
  const context = useContext(SearchFormOverlayContext);

  if (!context) {
    throw new Error(
      'useSearchFormOverlay() must be used within a <SearchFormOverlayProvider />'
    );
  }

  return context;
};
